import { required } from "@vuelidate/validators";

import Permission from "./permission";

export default class Group {
    constructor() {
        this.id = null;
        this.description = null;
        this.permissions = [new Permission()];
    }

    validations() {
        return {
            description: {
                required,
            },
            permissions: {
                required,
            },
        };
    }


}